import type { ChipProps } from '@dostavkee/web-ui'

import { DomainUserRoleStringEnum, UserStatusEnum } from '@/shared/api'

export const hasLatinLetters = (value: string): boolean => {
    return /^(?=.*[A-Za-z])[\w!#$%&()-_`{|}~]*$/.test(value)
}

export const hasDigitsOrSymbols = (value: string): boolean => {
    return /[\d!@#$%^&*()\-_=+[\]{};:'",.<>/?\\|`~]/.test(value)
}

export const MIN_PASSWORD_LENGTH = 8

export const ROLES = {
    superManager: DomainUserRoleStringEnum.UserRoleSuperManagerString,
    recruiter: DomainUserRoleStringEnum.UserRoleRecruiterString,
    apiIntegrator: DomainUserRoleStringEnum.UserRoleApiIntegratorString,
    unknown: DomainUserRoleStringEnum.UserRoleUnknownString,
}

export const ROLES_TO_TEXT = new Map<DomainUserRoleStringEnum, string>([
    [ROLES.superManager, 'Администратор'],
    [ROLES.recruiter, 'Вербовщик'],
    [ROLES.apiIntegrator, 'API-интегратор'],
    [ROLES.unknown, 'Неизвестная роль'],
])

export const USER_STATUS_TO_TEXT = new Map<UserStatusEnum, string>([
    [UserStatusEnum.userStatusActive, 'Активен'],
    [UserStatusEnum.userStatusInactive, 'Удалён'],
    [UserStatusEnum.userStatusPending, 'Не активирован'],
])

export const USER_STATUS_TO_CHIP = new Map<UserStatusEnum, ChipProps['variant']>([
    [UserStatusEnum.userStatusActive, 'secondary-deep'],
    [UserStatusEnum.userStatusInactive, 'primary'],
    [UserStatusEnum.userStatusPending, 'secondary-light'],
])
